module.exports = __webpack_public_path__ + "media/images/city/060-giralda-70669da7f95901aadb00f8c17f84c294.svg";